import React from "react";

const Paragraph = (props) => {
  return <p className="text-base text-center text-gray-700 font-normal font-lato">{props.children}</p>;
};

export default Paragraph;
